import { useSessionPermission } from '@btime/react-session'
import { path } from 'ramda'
import React from 'react'

import { Title } from '../../../../components/presentation/Text'
import Panel from '../../../../components/structure/Panel'
import FieldValuesPresenter from '../../../../containers/fieldValues/FieldValuesPresenter'

const CustomFieldsPanel = ({ serviceOrder }) => {
  const canSeeConfidentialFields = useSessionPermission('seeConfidentialFields')
  let fieldValues = serviceOrder?.fieldValues || []

  fieldValues = !canSeeConfidentialFields
    ? fieldValues.filter(fieldValue => !path(['field', 'configuration', 'confidential'], fieldValue))
    : fieldValues

  if (!fieldValues.length) return false

  return (
    <Panel lineBorder mediumPadding>
      <Title size="h6">Campos adicionais</Title>
      <FieldValuesPresenter fieldValues={fieldValues} canSeeConfidentialFields={canSeeConfidentialFields} />
    </Panel>
  )
}

export default CustomFieldsPanel
